module.exports = __webpack_public_path__ + "img/super.5301785a.svg";